module.exports = __webpack_public_path__ + "img/luxian-icon.12dbff51.svg";